import React from 'react';

export const Divider: React.FC = () => {
  return <div className="border-grey-300 h-0 border-0 border-b-0" />;
};
